import { EmployeesService } from '../../services/employees.service';
import { DeclarationService } from '../../services';
import { IDeclaration, IEmployee, Masterdata } from '../../services';
import * as moment from "moment";

interface IResolve {
    wageCodes: Masterdata[];
    declaration: IDeclaration;
    refresh: boolean;
}

class DeclarationController {

    private resolve: IResolve;
    private declaration: IDeclaration;
    private wageCodes: Masterdata[];
    private calendarStartDate: any;
    private calendarEndDate: any;

    constructor(
        private DeclarationService: DeclarationService,
        private EmployeesService: EmployeesService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.wageCodes = this.resolve.wageCodes;
        this.declaration = this.resolve.declaration;
        if (this.declaration) {
            this.declaration.dateTimeFrom = new Date(Date.parse(this.declaration.dateTimeFrom));
            this.declaration.dateTimeTo = new Date(Date.parse(this.declaration.dateTimeTo));
        } else {
            this.declaration = new IDeclaration();
            this.declaration.dateTimeFrom = this.$stateParams['shiftStartDate'];
            this.declaration.dateTimeTo = this.$stateParams['shiftEndDate'];
            this.declaration.shiftId = this.$stateParams['shiftId'];
            this.declaration.employeeId = this.$stateParams['employeeId'];
            this.declaration.registrationType = this.$stateParams['type'];
            this.declaration.status = 0;
        }
    }

    roundMinutes(date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    }

    startDateBeforeRender($dates) {
    }

    endDateBeforeRender($view, $dates) {
        if (this.declaration.dateTimeFrom) {
            var activeDate = moment(this.declaration.dateTimeFrom).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }

    submitDeclaration() {
        if (this.declaration.registrationType == '1') {
            var duration = moment.duration(moment(this.declaration.dateTimeTo).diff(moment(this.declaration.dateTimeFrom))).asHours();

            this.declaration.dateTimeFrom = moment(this.declaration.dateTimeFrom).format("YYYY-MM-DD HH:mm");
            this.declaration.dateTimeTo = moment(this.declaration.dateTimeTo).format("YYYY-MM-DD HH:mm");

            if (duration > 6) {
                this.SweetAlert.swal({
                    title: 'Let op!',
                    text: 'In geval van pauzes, maak 2 declaraties aan.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2ECC71',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ja',
                    cancelButtonText: 'Nee, annuleren',
                }, (isConfirm) => {
                    if (isConfirm) {
                        this.saveDeclaration();
                    } else { }
                });
            } else {
                this.saveDeclaration();
            }
        } else {
             if (!this.declaration.wageCodeId) {
                this.SweetAlert.swal({
                    title: 'Let op!',
                    text: 'Vul een type in',
                    type: 'warning',
                    confirmButtonColor: '#2ECC71',
                    confirmButtonText: 'Ok',
                });
            } else {
                this.declaration.dateTimeFrom = null;
                this.declaration.dateTimeTo = null;
                this.saveDeclaration();
            }
        }
        
    }

    saveDeclaration() {
        if (!this.declaration.id) {
            this.DeclarationService.post(this.declaration).then((result: any) => {
                this.closeModal();
            });
        } else {
            this.DeclarationService.put(this.declaration.id, this.declaration).then(result => {
                this.closeModal();
            });
        }
    }

    wageCodeUpdated() {
        var wageCode = this.wageCodes.find(w => w.id == this.declaration.wageCodeId);
        this.declaration.wageCodeCode = (<any>wageCode).code;
    }

    deleteDeclaration() {
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze declaration wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d96557',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.DeclarationService.delete(this.declaration.id).then(() => {
                    this.closeModal();
                });
            } else {

            }
        });
    }

    private closeModal() {
        if(this.resolve.refresh){
            this.$state.go('^', {"openShiftId": this.declaration.shiftId}, {reload: true});
        } else {
            this.$state.go('^', {"openShiftId": this.declaration.shiftId}, {reload: false});
        }
    }
}

export const declarationComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: DeclarationController,
    template: require('./declaration.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/timesheets/declaration.component.ts